module.exports = __webpack_public_path__ + "img/arrow-up-left.32e74eb4.svg";